<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div v-if="userPermissions.indexOf('add_contact_extension') > -1" class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">Department Extension List</div>
                <!--<button type="submit" v-on:click.prevent="addContact" class="btn btn-primary waves-effect pull-right">Add</button>-->
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <div class="app-filter-good-table-container">
                    <!-- List Content Here -->
                    <vue-good-table
                        ref="LocationContactExtensionList"
                        mode="remote"
                        title="Location Contact Extension List"
                        @on-page-change="onPageChange"
                        @on-selected-rows-change="selectionChanged"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        :totalRows="totalRecords"
                        :columns="columns"
                        :rows="rows"
                        :pagination-options="{
                        enabled: true,
                        mode: 'pages',
                        pageLabel: 'Page',
                        position: 'bottom',
                        perPage: serverParams.perPage,
                        perPageDropdown: [25, 50, 100, 200 ,500],
                        dropdownAllowAll: false,
                        }"

                        :search-options="{
                        enabled: false,
                        }">

                        <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                            <div :key="key">
                                <!--class="btn btn-xs btn-primary"-->
                                <div v-if="props.column.field == 'action'" class="table-action">
                                    <router-link title='Edit Contact' class="btn edit-btn-vvg waves-effect" v-bind:to="{name: 'UpdateDepartmentContact',params:{id:props.row.site_id + '_' + props.row.department_id}}"><i class="fa fa-pencil" aria-hidden="true"></i></router-link>
                                </div>
                                <div v-else>
                                    {{props.formattedRow[props.column.field]}}
                                </div>
                            </div>
                        </template>
                    </vue-good-table>
                </div>
            </div>
            <!--page content-->
        </div>
        <div v-else class="container-fluid xyz">
            <div class="page-name">
                Oops...!
            </div>
            <div class="admin-page-content">
                Sorry, You don't have permission to access this page.
            </div>
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/Footer';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    Vue.use(VueGoodTable);
    import EventBus from '../../event-bus';
    import SessioMixin from '../../../mixins/sessionmixin';
    import { HTTP } from '../../../http-common';

    var self;
    export default {
        name: 'ListLocationContacts',
        components: {
            'app-backend-footer': BackendFooter,
        },
        mixins: [SessioMixin],
        data() {
            return {
                isShowLoggedinfields: true,
                userPermissions: ['add_contact_extension'],
                roleId: 0,
                roleName: 0,
                system_year: '',
                sitesData: [],
                sitesArr: [],
                firstLoad: 0,
                columns: [
                    {
                        label: 'Location',
                        field: 'site_name',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Location", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Department',
                        field: 'dept_name',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Department", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Updated At',
                        field: 'updated_at',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
//                            placeholder: "MM/DD/YYYY",
                            enabled: true, // enable filter for this column
                            placeholder: "MM/DD/YYYY", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Updated By',
                        field: 'updated_by',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Updated By", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    }, {
                        label: 'Actions',
                        field: 'action',
                        html: true,
                        sortable: false,
                        thClass: 'disable-sorting',
                    },
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    page: 1,
                    perPage: 25,
                    sort: {
                        field: 'updated_at',
                        type: 'desc',
                    },
                },
                recordsCounts: "",
                selectedRows: 0,
            }

        },
        watch: {
            serverParams: {
                handler(object) {
                    var self = this;
                    if (object.columnFilters.site_name != '') {
                        $.each(self.sitesData, function (i) {
                            if (self.sitesData[i].text == object.columnFilters.site_name) {
                                self.loadDepartments(self.sitesData[i].value);
                            }
                        });
                    } else {
                        self.loadDepartments();
                    }
                },
                deep: true
            },
        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
            //self.checkLogin();
        },
        mounted: function () {
//            self = this;
            self.getPermissions();
            self.loadSites();
            self.loadDepartments();
            self.loadDepartmentContacts();
        },
        methods: {
            addContact() {
                self.$router.push('/backend/addcontact');
            },

            updateParams(newProps) {
                self.serverParams = Object.assign({}, self.serverParams, newProps);
            },
            onPageChange(params) {
                self.updateParams({page: params.currentPage});
                self.loadDepartmentContacts();
            },
            onPerPageChange(params) {
                if (params.currentPerPage != self.serverParams.perPage) {
                    self.updateParams({perPage: params.currentPerPage});
                    self.totalRecords = self.totalRecords;
                    self.loadDepartmentContacts();
                }
            },
            onColumnFilter(params) {
                self.updateParams(params);
                {
                    field: ('site_id');
                    field: ('site_name');
                    field: ('site_alias');
                    field: ('department_id');
                    field: ('dept_name');
                    field: ('dept_alias');
                    field: ('created_by');
                    field: ('updated_by');
                    field: ('created_at');
                    field: ('updated_at');
                }
                ;
                self.serverParams.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(self.serverParams));
                var filters = filtersPr.columnFilters;

                if (self.firstLoad == 1 || filters.site_id || filters.site_name || filters.site_alias || filters.department_id
                        || filters.dept_name || filters.dept_alias || filters.created_by || filters.updated_by || filters.created_at
                        || filters.updated_at) {
                    self.loadDepartmentContacts();
                }

            },
            selectionChanged() {
                self.selectedRows = (self.$refs['LocationContactExtensionList'].selectedRows).length;
                /*console.log(self.selectedRows);*/
            },
            onSortChange(params) {
                self.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                self.loadDepartmentContacts();
            },
            loadSites() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        get_all: 1
                    }
                };
                HTTP.get("ce-getsite", config)
                        .then(function (response) {
                            self.sitesArr = [];
                            self.sitesData = [];
                            // self.sitesArr = response.data.content;
                            $.each(response.data.content, function (i) {
                                self.sitesArr.push(response.data.content[i].text);
                                self.sitesData.push(response.data.content[i]);
                            });
                            $.each(self.columns, function (i) {
                                if (self.columns[i].field == 'site_name') {
                                    self.columns[i].filterOptions.filterDropdownItems = self.sitesArr;
                                }
                            });
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            loadDepartments(site) {
                site = (site === null || typeof (site) === "undefined" || site == '') ? '' : site;
                var config = {};
                if (site != '') {
                    config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                        params: {
                            site: site
                        }
                    };
                } else {
                    config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                        params: {
                            get_all: 1
                        }
                    };
                }
                HTTP.get("ce-getdepartment", config)
                        .then(function (response) {
                            self.sitesArr = [];
                            // self.sitesArr = response.data.content;
                            $.each(response.data.content, function (i) {
                                self.sitesArr.push(response.data.content[i].text);
                            });
                            $.each(self.columns, function (i) {
                                if (self.columns[i].field == 'dept_name') {
                                    self.columns[i].filterOptions.filterDropdownItems = self.sitesArr;
                                }
                            });
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            loadDepartmentContacts: function () {
                self.firstLoad = 1;
                var newPage = Math.ceil(self.totalRecords / self.serverParams.perPage)
                if (newPage) {
                    if (newPage < self.serverParams.page) {
                        self.serverParams.page = newPage;
                    }
                }
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        page: self.serverParams.page,
                        perPage: self.serverParams.perPage,
                        filters: self.serverParams.columnFilters,
                        messageData: self.message,
                        sort: self.serverParams.sort
                    }
                };
                HTTP.get('listdepartmentcontact', config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                self.rows = response.data.content.row;
                                self.totalRecords = response.data.content.totalRecords;
                            }

                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        localStorage.removeItem("profile_image");
                                        self.$router.push("/login");
                                        //EventBus.$emit("logged-in", true, "", "");
                                    }
                                    self.error = err.response.data.message;
                                }
                            }
                        })
            },

        }
    }
    EventBus.$on('role', function (isLogin, id, name, system_year, userPermissions) {
        if (typeof (self) != "undefined") {
            self.isShowLoggedinfields = isLogin;
            self.roleId = id;
            self.userPermissions = userPermissions;
            self.roleName = name;
            self.system_year = system_year;
        }
    });
</script>



// WEBPACK FOOTER //
// src/components/backend/contactextension/DepartmentListContact.vue